// ΔVΔVΔ:  Accomidate screens that are short/wide
// to test use a CDC laptops, go to settings > display > scale & layout & set to 150
// at this time this doesn't see to actualy affect the app anymore. This may have been resolved by using grid css later in development

const checkAdjustShortScreens = (olmap) => {
    const inter = document.querySelector('#interface');
    if (!inter) return;
    if (inter.offsetWidth < 1200) return;

    const uiNodes = Array.from(document.querySelectorAll('#tabs, #view-controls, #data-controls, #cdc-header, #svi-banner'));
    var uiHeight = uiNodes.reduce((total, elem) => total + elem.offsetHeight, 0);

    if (inter.classList.contains('short')) {
        uiHeight += 80; //ΔVΔVΔ: There could be a non hardcoded way to get this number
    }
    const contentHeight = document.body.offsetHeight;
    const maxUIspace = contentHeight / 2;
    if (!inter) return;
    if (uiHeight > maxUIspace && !inter.classList.contains('short')) {
        olmap.updateSize();
        console.log('recalc size');
    } else if (inter.classList.contains('short')) {
        olmap.updateSize();
        console.log('recalc size');
    }
};

export { checkAdjustShortScreens };
